<template>
  <div class="metric-cell">
    <div class="metric-cell-primary">{{ primary }}</div>
    <div v-if="secondary" class="metric-cell-secondary">{{ secondary }}</div>
    <div class="metric-cell-footer">
      <span class="metric-cell-footer-value metric-cell-footer-value--blue">{{ footerLeft }}</span>
      <span class="metric-cell-footer-separator">/</span>
      <span class="metric-cell-footer-value metric-cell-footer-value--orange">{{
        footerRight
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManagerAnalyticsMetricCell",

  props: {
    primary: {
      type: String,
      default: "0",
    },

    secondary: {
      type: String,
      default: null,
    },

    footerLeft: {
      type: String,
      default: "0",
    },

    footerRight: {
      type: String,
      default: "0",
    },
  },
};
</script>

<style lang="postcss" scoped>
.metric-cell {
  @apply flex flex-col gap-1;

  &-primary {
    @apply text-sm font-bold text-gray-900;
  }

  &-secondary {
    @apply text-xs text-gray-500;
  }

  &-footer {
    @apply flex items-center gap-1 text-xs;
  }

  &-footer-value {
    @apply font-medium;

    &--blue {
      @apply text-blue-500;
    }

    &--orange {
      @apply text-orange-500;
    }
  }

  &-footer-separator {
    @apply text-gray-400;
  }
}
</style>
